module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"back":"Return to homepage","logout":"Log out"},"zh-CN":{"back":"回到首页","logout":"退出登录"},"zh-TW":{"back":"回到首页","logout":"退出登錄"},"it":{"back":"Torna alla homepage","logout":"Esci"},"id":{"back":"Kembali ke beranda","logout":"Keluar"}}')
  delete Component.options._Ctor
}
